import Table from '@/components/table/components/Table.tsx';
import insuredParticipantsApi from '@/features/dashboard/insurances/api/insuredParticipantsApi.ts';
import { insuredParticipantsApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const InsuredParticipantsTable = () => {
  return (
    <Table
      queryKey={insuredParticipantsApiQueryKeys.all()}
      fetchData={insuredParticipantsApi.getAll}
      fetchTableDef={insuredParticipantsApi.getTableDefinition}
      tagTargetType={TaggableType.INSURANCE}
    />
  );
};

export default InsuredParticipantsTable;
